import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { VIEW_ALL_COMMUNICATIONS } from "@/utils/permissions";

export default {
  data() {
    return {
      permissionInfoText: {
        index: "Permette di accedere al modulo della risorsa",
        show: "Permette di aprire il dettaglio",
        store: "Permette di creare nuovi record",
        update: "Permette di modificare i record",
        destroy: "Permette di eliminare i record",
        download: "Permette di scaricare l'export CSV",
        view_all: "Vede e gestisce procedure e log di invio di tutti gli utenti",
      },
      resourceDictionary: {
        tasks: "Note, Attività, Appuntamenti",
        note_templates: "Template Note",
        registries: "Anagrafiche",
        attributes: "Campi Aggiuntivi",
        agency_contacts: "Contatti",
        agency_setups: "Impostazioni di agenzia",
        analyses: "Analisi",
        claims: "Sinistri",
        claim_parties: "Associati Sinistri",
        correspondences: "Indirizzi",
        councils: "Comuni",
        countries: "Nazioni",
        book_tags: "Codice Documento",
        provinces: "Province",
        documents: "Documenti",
        generated_reports: "Report Generati",
        reports: "Report",
        insurance_risks: "Rischi",
        insurers: "Compagnie",
        registry_groups: "Gruppi",
        risk_branches: "Rami di Rischio",
        risk_types: "Tipi di Rischio",
        insurance_policies: "Polizze",
        address_books: "Recapiti",
        insurance_ancillaries: "Titoli",
        insurance_payments: "Quietanzamenti",
        relative_types: "Relazioni",
        users: "Utenti",
        importers: "Importatori",
        import_logs: "Log Importatori",
        import_maps: "Mappatura Importatori",
        agency_books: "Contabilità di Agenzia",
        book_entries: "Foglio Cassa",
        breakdowns: "Scorpori",
        broker_statements: "Contabilità Produttori",
        brokers: "Produttori / Collaboratori",
        commissions: "Capitolato",
        consolidated_treasuries: "Consolidamenti",
        entry_details: "Dettagli Foglio Cassa",
        insurer_accountings: "Contabilità Compagnie",
        payment_references: "Causali",
        sectors: "Comparti",
        treasuries: "Forme di Pagamento",
        various_accountings: "Movimenti Vari",
        unsolved_payments: "Insoluti",
        mandate_codes: "Codici Mandato",
        cash_entries: "Movimenti",
        movimenti_prima_nota: "Movimenti",
        cash_references: "Causali",
        import_details: "Dettaglio importatori",
        insurer_participants: "Compagnie coassicuratrici",
        causali_prima_nota: "Causali",
        bank_accounts: "Conti correnti",
        direct_debits: "Mandati SDD",
        payment_procedures: "Procedure di incasso",
        fattutto: "Fattutto",
        communication_procedures: "Procedure di comunicazione",
      },
      /* Etichette brevi, sono le intestazioni di colonna della matrice */
      permissionDictionary: {
        index: "Elenco",
        show: "Dettaglio",
        store: "Crea",
        update: "Modifica",
        destroy: "Elimina",
        download: "Scarica",
        send: "Invio",
        config: "Configurazione",
        view_all: "Vede tutti",
      },
    };
  },
  methods: {
    /* Data utils */
    groupByModule(data) {
      const modules = [];
      /* il LIKE lato backend può restituire lo stesso permesso in più
       * moduli: un solo oggetto per id tiene allineate le tabelle */
      const byId = {};
      for (const mod in data) {
        /* raggruppa per risorsa senza dipendere dall'ordine dei permessi:
         * il LIKE lato backend può alternare risorse affini (reports e
         * generated_reports) */
        const resources = {};
        data[mod].forEach((permission) => {
          /* il LIKE intercetta anche le rotte v2.* (es. v2.registries) */
          if (!permission.name.startsWith("resources.")) {
            return;
          }
          const [, resource, action] = permission.name.split(".");
          /* delle procedure di comunicazione (risorsa esclusa) si assegna
           * solo il permesso di vedere quelle di tutti */
          const shown =
            permission.name === VIEW_ALL_COMMUNICATIONS ||
            (this.skipResource(resource) && this.skipPermission(action));
          if (!shown) {
            return;
          }
          if (!resources[resource]) {
            resources[resource] = { name: resource, permissions: [] };
          }
          if (!byId[permission.id]) {
            byId[permission.id] = {
              id: permission.id,
              name: permission.name,
              action: action,
              user_id: this.user.id,
              check: permission.value === "Y",
            };
          }
          resources[resource].permissions.push(byId[permission.id]);
        });
        modules.push({
          name: mod,
          alias: mod.replaceAll(" ", "_"),
          resources: Object.values(resources),
        });
      }
      return { modules };
    },
    skipPermission(action) {
      const excludedActions = ["edit", "create"];
      return !excludedActions.includes(action);
    },
    skipResource(resource) {
      const excludedResources = [
        "import_logs",
        "provinces",
        "countries",
        "risk_types",
        "risk_branches",
        "users",
        "job_spools",
        "tags",
        "communication_procedures",
        "communication_details",
        "communication_groupings",
        "categories",
        "import_groups",
        "import_files",
        "temp_imports",
      ];
      return !excludedResources.includes(resource);
    },

    /* Dictionaries */
    hasResourceLabel(resource) {
      return !!this.resourceDictionary[resource];
    },
    resourcesDictionary(resource) {
      return this.resourceDictionary[resource] ?? this.humanize(resource);
    },
    hasPermissionLabel(action) {
      return !!this.permissionDictionary[action];
    },
    permissionsDictionary(action) {
      return this.permissionDictionary[action] ?? this.humanize(action);
    },
    showPermissionInfo(action) {
      return this.permissionInfoText[action] ?? "";
    },
    humanize(key) {
      const text = `${key}`.replace(/[_-]+/g, " ");
      return text.charAt(0).toUpperCase() + text.slice(1);
    },

    /* API calls*/
    deletePermission(permission) {
      const Repo = RepositoryFactory.get("user");
      return Repo.destroy_permission(permission.user_id, permission.id);
    },
    addPermission(permission) {
      const Repo = RepositoryFactory.get("user");
      return Repo.store_permission(permission.user_id, {
        permission_id: permission.id,
      });
    },
  },
};
